import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ApiStatusCode } from '@app/shared/constants';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { OrderItem } from '@app/shared/services/order/GetOrders.interface';
import { OrderService } from '@app/shared/services/order/order.service';
import { constants } from 'os';

export interface ReportOrderComponentData {
  OrderId: number;
  OrderNo: string;
  OrderItems: OrderItem[];
}

@Component({
  selector: 'app-report-order',
  templateUrl: './report-order.component.html',
  styleUrls: ['./report-order.component.css']
})
export class ReportOrderComponent implements OnInit {

  reportOrderForm: FormGroup;
  @ViewChild('fileInput') fileInput!: any;
  images = [];
  problemTypes: string[] = [
    'Defective Garment',
    'Incorrect Garment Color',
    'Incorrect Garment Size',
    'Lost Package',
    'Print Quality - Sizing',
    'Print Quality - Coloring',
    'Print Quality - Stains',
    'Print Placement',
    'Other',
  ];
  order: ReportOrderComponentData;
  files: any[];
  fileName: string;

  constructor(
    private formBuilder: FormBuilder,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private orderService: OrderService,
    @Inject(MAT_DIALOG_DATA) public data: ReportOrderComponentData,
    public dialogRef: MatDialogRef<ReportOrderComponentData>,
    private errorhandlerService: ErrorhandlerService
  ) { }

  ngOnInit() {
    this.fileName = '';
    this.files = [];
    this.order = this.data;
    this.reportOrderForm = this.formBuilder.group({
      orderItems: new FormControl('', Validators.compose([Validators.required])),
      problemTypes: new FormControl('', Validators.compose([Validators.required])),
      notes: new FormControl('', Validators.compose([Validators.required])),
      file: new FormControl('')
    })
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.reportOrderForm.controls;
  }

  onFileChange(event) {
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        if (this.files.length >= 10) {
          this.notificationService.error('Only 10 files are allowed', 'Maximum reached');
          return;
        }

        const type = event.target.files[i].type;
        const size = event.target.files[i].size;
        if (type !== 'image/jpeg' && type !== 'image/jpg' && type !== 'image/png' && type !== 'image/gif') {
          this.fileInput.nativeElement.value = '';
          this.notificationService.error('Invalid type file. Make sure you are uploading Images only.', 'Type');
          return;
        }
        if (Math.round(size / 1024) >= 5242) {
          this.fileInput.nativeElement.value = '';
          this.notificationService.error('Size must be less than 5 Mb', 'Size');
          return;
        }
        else {
          this.fileName += event.target.files[i].name + ', ';
          this.files.push(event.target.files[i]);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.images.push(event.target.result);
          }
          reader.readAsDataURL(event.target.files[i]);
        }
      }
    }
  }

  fn_Submit() {
    let value = this.reportOrderForm.value;
      const formData = new FormData();
      formData.append('OrderId', this.order.OrderId.toString());
      formData.append('Notes', value.notes);
      value.orderItems.forEach(id => {
        formData.append('CartItemIds', id.toString());
      });
      value.problemTypes.forEach(problemType => {
        formData.append('ProblemTypes', problemType.toString());
      });
      this.files.forEach(file => {
        formData.append('files', file, file.name);
      });
      this.loader.show();
    if(localStorage.role == 'SuperAdmin' || localStorage.role == 'CustomerService' ) {
      this.orderService.ReportOrderReplacement(formData)
        .subscribe((res: any) => {
          if (res.StatusCode == ApiStatusCode.SUCCESS) {
            this.reportOrderForm.reset();
            this.images = [];
            this.notificationService.success('Your request has been submitted', 'Report order');
            this.dialogRef.close();
          } else {
            this.notificationService.error(res.Message, 'Error');
          }
          this.loader.hide();
        }, err => {
          console.error(err);
          this.errorhandlerService.handleError(err);
          this.loader.hide();
        });
    }else{
      this.orderService.ReportOrder(formData)
        .subscribe((res: any) => {
          if (res.StatusCode == ApiStatusCode.SUCCESS) {
            this.reportOrderForm.reset();
            this.images = [];
            this.notificationService.success('Your request has been submitted', 'Report order');
            this.dialogRef.close();
          } else {
            this.notificationService.error(res.Message, 'Error');
          }
          this.loader.hide();
        }, err => {
          console.error(err);
          this.errorhandlerService.handleError(err);
          this.loader.hide();
        });
    }
  }
}
